'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _FullScreenModal = require('./FullScreenModal');

var _FullScreenModal2 = _interopRequireDefault(_FullScreenModal);

var _Icon = require('../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

require('./FullScreenErrorModal.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Icons
// Lib
var FullScreenErrorModal = function FullScreenErrorModal(_ref) {
    var children = _ref.children,
        className = _ref.className,
        overlay = _ref.overlay,
        close = _ref.close;
    return _react2.default.createElement(
        _FullScreenModal2.default,
        { className: (0, _classnames2.default)('FullScreenErrorModal', className), overlay: overlay, close: close },
        _react2.default.createElement(
            'div',
            { className: 'logo' },
            _react2.default.createElement(_Icon2.default, { name: 'error-alert' })
        ),
        children
    );
};

// Styles


// Components


FullScreenErrorModal.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array]).isRequired,
    overlay: _propTypes2.default.bool,
    close: _propTypes2.default.func,
    className: _propTypes2.default.string
};

exports.default = FullScreenErrorModal;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/modal/FullScreenErrorModal.js
// module id = 139
// module chunks = 0